module.exports = __webpack_public_path__ + "img/white-shape.03437acd.svg";